import { css } from 'styled-components';
import { getFormattedSpaceValue } from './getFormattedSpaceValue';
export const gridKeys = [
    'alignContent',
    'alignItems',
    'columnGap',
    'gridAutoColumns',
    'gridAutoFlow',
    'gridAutoRows',
    'gridTemplateAreas',
    'gridTemplateColumns',
    'gridTemplateRows',
    'justifyContent',
    'justifyItems',
    'rowGap',
    'alignSelf',
    'gridArea',
    'gridColumn',
    'gridColumnEnd',
    'gridColumnStart',
    'gridRow',
    'gridRowEnd',
    'gridRowStart',
    'justifySelf',
];
export const grid = css `
  ${({ $alignContent, $alignItems, $columnGap, $gridAutoColumns, $gridAutoFlow, $gridAutoRows, $gridTemplateAreas, $gridTemplateColumns, $gridTemplateRows, $justifyContent, $justifyItems, $rowGap, }) => `
    ${$gridAutoFlow ? `grid-auto-flow: ${$gridAutoFlow};` : ''}
    ${$gridAutoColumns ? `grid-auto-columns: ${$gridAutoColumns};` : ''}
    ${$gridAutoRows ? `grid-auto-rows: ${$gridAutoRows};` : ''}

    ${$gridTemplateAreas ? `grid-template-areas: ${$gridTemplateAreas};` : ''}
    ${$gridTemplateColumns
    ? `grid-template-columns: ${$gridTemplateColumns};`
    : ''}
    ${$gridTemplateRows ? `grid-template-rows: ${$gridTemplateRows};` : ''}

    ${$justifyItems ? `justify-items: ${$justifyItems};` : ''}
    ${$alignItems ? `align-items: ${$alignItems};` : ''}

    ${$justifyContent ? `justify-content: ${$justifyContent};` : ''}
    ${$alignContent ? `align-content: ${$alignContent};` : ''}

    ${$columnGap
    ? `
          grid-column-gap: ${getFormattedSpaceValue($columnGap)};
          column-gap: ${getFormattedSpaceValue($columnGap)};
          `
    : ''}
    ${$rowGap
    ? `
          grid-row-gap: ${getFormattedSpaceValue($rowGap)};
          row-gap: ${getFormattedSpaceValue($rowGap)};
          `
    : ''}
  `}
`;
export const gridItem = css `
  ${({ $alignSelf, $gridArea, $gridColumn, $gridColumnEnd, $gridColumnStart, $gridRow, $gridRowEnd, $gridRowStart, $justifySelf, }) => `
    ${$gridArea ? `grid-area: ${$gridArea};` : ''}
    
    ${$gridColumn ? `grid-column: ${$gridColumn};` : ''}
    ${$gridColumnStart ? `grid-column-start: ${$gridColumnStart};` : ''}
    ${$gridColumnEnd ? `grid-column-end: ${$gridColumnEnd};` : ''}
    
    ${$gridRow ? `grid-row: ${$gridRow};` : ''}
    ${$gridRowStart ? `grid-column-start: ${$gridRowStart};` : ''}
    ${$gridRowEnd ? `grid-column-end: ${$gridRowEnd};` : ''}
    
    ${$alignSelf ? `align-self: ${$alignSelf};` : ''}
    ${$justifySelf ? `justify-self: ${$justifySelf};` : ''}
  `}
`;
